var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"agent-profiles"},_vm._l((_vm.listing.Agents),function(agent){return _c('div',{key:agent.Id},[_c('ProfileCard',{attrs:{"profile":agent}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }